import { BlessingResponse } from "api"
import { useIsDesktop } from "common/MediaQueries"
import slugify from "common/utils/slugify"
import { useCreateAiContext } from "components/CreateAi/CreateAiContext"
import { usePurchaseContext } from "components/PurchasePage/PurchaseContext"
import { useRouter } from "next/router"
import styled, { css } from "styled-components"
import { Navigation, Pagination } from "swiper"
import "swiper/css"
import "swiper/css/bundle"
import "swiper/css/pagination"
import { Swiper, SwiperSlide } from "swiper/react"
import { slideIn } from "theme/animation"
import colors from "theme/colors"
import CategoryCard from "./Card"

const StyledSwiper = styled(Swiper)<{ $visible: boolean }>`
  width: 100%;
  height: 100%;
  margin-bottom: 80px;
  margin-top: 13px;
  &:last-child {
    margin-bottom: 60px;
    overflow: visible;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-bottom: 40px;
    padding-right: 16px;
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: ${colors.white};
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    align-items: start;

    // BEN UPDATE
    width: auto;

    ${(p) =>
      p.$visible &&
      css`
        animation: ${slideIn} 1s ease-out;
        animation-fill-mode: forwards;
        animation-iteration-count: 1;
      `}
    &:nth-child(1) {
      animation-delay: 0.2s;
    }
    &:nth-child(2) {
      animation-delay: 0.4s;
    }
    &:nth-child(3) {
      animation-delay: 0.6s;
    }
    &:nth-child(4) {
      animation-delay: 0.8s;
    }
    &:nth-child(5) {
      animation-delay: 1s;
    }

    ${(p) => p.theme.breakpoints.down("sm")} {
      backdrop-filter: blur(3.5px);
      -webkit-backdrop-filter: blur(3.5px);
      -moz-backdrop-filter: blur(3.5px);
      span:nth-child(2) {
        img {
          display: block;
          max-width: 100%;
          width: initial;
          height: initial;
          background: none;
          opacity: 1;
          border: 0;
          margin: 0;
          padding: 0;
        }
      }
      span:first-child {
        img:nth-child(2) {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          box-sizing: border-box;
          padding: 0;
          border: none;
          margin: auto;
          display: block;
          width: 0;
          height: 0;
          min-width: 100%;
          max-width: 100%;
          min-height: 100%;
          max-height: 100%;
        }
      }
    }
  }
`

const swiperBreakpoints = {
  640: {
    slidesPerView: "auto",
    slidesPerGroup: 1,
    slidesOffsetBefore: 0,
  },
}

type CategoryImageSlider = {
  blessing: BlessingResponse[]
  bonusText: string
  categoryName: string
  inView: boolean
  isHomePage?: boolean
}

const CategoryImageSlider = ({
  blessing,
  bonusText,
  categoryName,
  inView,
  isHomePage,
}: CategoryImageSlider) => {
  const isDesktop = useIsDesktop()
  const router = useRouter()
  const { setPromotion, setCategoryName, setPrevPath } = usePurchaseContext()
  const {
    setBlessingId,
    setPropertiesData,
    setStylesData,
    setBackgroundsData,
    setSenderBlessingAi,
  } = useCreateAiContext()
  const saveCategory = () => {
    setPromotion(bonusText)
    setCategoryName(categoryName)
    setPrevPath(router.pathname)
  }

  return (
    <StyledSwiper
      slidesPerView={2.2}
      spaceBetween={10}
      slidesPerGroup={2}
      loop={false}
      loopFillGroupWithBlank={true}
      modules={[Pagination, Navigation]}
      // @ts-ignore
      breakpoints={swiperBreakpoints}
      slidesOffsetBefore={isDesktop && 2}
      $visible={inView}
    >
      {blessing.map((data) => (
        <SwiperSlide key={data.id}>
          <CategoryCard
            href={
              data.slug
                ? data.isAiImage
                  ? `/create-ai`
                  : `/giftcard/${slugify(data?.slug)}`
                : "/"
            }
            isHomePage={isHomePage}
            onClick={() => {
              if (data.isAiImage) {
                setBlessingId(data.id)
                setPropertiesData([])
                setStylesData(null)
                setBackgroundsData(null)
                setSenderBlessingAi("")
              }
              saveCategory()
            }}
            data={data}
          />
        </SwiperSlide>
      ))}
    </StyledSwiper>
  )
}

export default CategoryImageSlider
